import { Tag } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { useRiscosQuery } from 'graphql/hooks.generated'
import { useAlertasSdc } from 'hooks/sdc/useAlertasSdc'
import { useMemo } from 'react'

interface RiscoPreEclampsiaTagProps {
  dataTestId?: string
  prontuarioId?: ID
}

export function RiscoPreEclampsiaTag({ dataTestId, prontuarioId }: Readonly<RiscoPreEclampsiaTagProps>) {
  const alertasSdcContext = useAlertasSdc()

  const { PILOTO_RISCOS_SDC_ENABLED } = useFlags()

  const { data, loading: loadingRiscos } = useRiscosQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        prontuarioId,
        ativo: true,
      },
    },
    skip: !prontuarioId || !PILOTO_RISCOS_SDC_ENABLED,
  })

  // TODO@Codebenders: substituir esta lógica pelo hook de verificação do Risco de Pré-Eclâmpsia quando disponível (issue #25073).
  const hasAlertaRiscoPreEclampsia = useMemo(() => {
    const hasRiscoPersistidos = data?.riscos?.some((risco) => risco.grupo === 'PRE_ECLAMPSIA') ?? false

    const hasRiscoSdc = alertasSdcContext?.alertasSdc?.some((alerta) => alerta.id === 'ALERTA_PRE_ECLAMPSIA') ?? false

    return hasRiscoPersistidos || hasRiscoSdc
  }, [data?.riscos, alertasSdcContext?.alertasSdc])

  if (loadingRiscos) {
    return null
  }

  return hasAlertaRiscoPreEclampsia ? (
    <Tag type='danger' data-testid={dataTestId}>
      Identificado
    </Tag>
  ) : (
    <Tag type='normal' data-testid={dataTestId}>
      Não identificado
    </Tag>
  )
}
